import AnimatedBackground from "../../components/AnimatedBackground/AnimatedBackground.jsx";
import Anim from "../../components/AnimationWave/AnimationWave.jsx";
import logo from "../../assets/logoDA.png";
import Loader from "../../components/Loader/Loader.jsx";
import { HelmetProvider, Helmet } from "react-helmet-async";

function Welcome() {
  return (
    <HelmetProvider>
      <Helmet>
        <link rel="canonical" href="https://www.devalls.com/" />
      </Helmet>

      <main className="welcomeMain">
        <Loader />
        <section
          id="welcome-hero"
          className="welcome-hero"
          style={{ position: "relative", overflow: "hidden" }}
        >
          <AnimatedBackground />
          <Anim />
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center welcomeLogo">
                <img className="logoWelcome" src={logo} alt="logo" />
                <div className="header-text">
                  <div className="h_title">
                    <h1 className="h1_title">DEV'ALLS</h1>
                    <h2 className="h2_title">
                      Donnez vie a vos projets d'enfer !
                    </h2>
                  </div>
                  <div className="download">
                    <a className="downloadCv" href="/devalls">
                      Découvrez notre univers !
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </HelmetProvider>
  );
}

export default Welcome;
